import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.PublicCustomerOrderPage.title',
    defaultMessage: 'Good news! Your files are ready',
  },
  subtitle: {
    id: 'containers.PublicCustomerOrderPage.subtitle',
    defaultMessage: 'Go ahead a click on them to listen. Share the files using the following link. Note that the files are available until the order is closed.',
  },
  titleInactive: {
    id: 'containers.PublicCustomerOrderPage.inactive.title',
    defaultMessage: "..and Bob's your uncle.",
  },
  subtitleInactive: {
    id: 'containers.PublicCustomerOrderPage.inactive.subtitle',
    defaultMessage: 'The files available on this order have been delivered, and the order has been closed.',
  },
  copy: {
    id: 'containers.PublicCustomerOrderPage.copy',
    defaultMessage: 'Copy',
  },
  copied: {
    id: 'containers.PublicCustomerOrderPage.copied',
    defaultMessage: 'Copied',
  },
  next: {
    id: 'containers.PublicCustomerOrderPage.next',
    defaultMessage: 'Next',
  },
  previous: {
    id: 'containers.PublicCustomerOrderPage.previous',
    defaultMessage: 'Previous',
  },
  playPause: {
    id: 'containers.PublicCustomerOrderPage.playPause',
    defaultMessage: 'Play/Pause',
  },
  pageTitle: {
    id: 'containers.PublicCustomerOrderPage.pageTitle',
    defaultMessage: '{customerName} x {partnerName}',
  },
  downloadAllFiles: {
    id: 'containers.PublicCustomerOrderPage.downloadAllFiles',
    defaultMessage: 'Download all files',
  },
})
